var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUsersAndRolesHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8017_7420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8017_7420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47059 0H0V6.80232H6.47059V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8017_7420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.32558 3.96814H2.14553C1.79121 3.96858 1.45152 4.11677 1.20099 4.38016C0.950452 4.64356 0.809502 5.00063 0.809082 5.37311V6.80246H5.66202V5.37311C5.66157 5.00063 5.52064 4.64356 5.2701 4.38016C5.01955 4.11677 4.67991 3.96858 4.32558 3.96814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2358 3.40116C4.1292 3.40116 4.85345 2.63979 4.85345 1.70059C4.85345 0.76138 4.1292 0 3.2358 0C2.3424 0 1.61816 0.76138 1.61816 1.70059C1.61816 2.63979 2.3424 3.40116 3.2358 3.40116Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8017_7420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8017_7420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 2.19763H4.5293V9H10.9999V2.19763Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8017_7420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1375 6.83426V7.1179H10.6698C10.6376 7.5183 10.4717 7.8938 10.2016 8.1779C9.9314 8.4621 9.5745 8.6366 9.1938 8.6705V8.1105H8.9242V8.6705C8.5436 8.6366 8.1866 8.4621 7.91651 8.1779C7.64639 7.8938 7.48052 7.5183 7.44825 7.1179H7.98059V6.83426H7.44825C7.47804 6.46486 7.62153 6.11664 7.85568 5.8418H7.16018C6.80586 5.84225 6.46618 5.99052 6.21563 6.25405C5.96511 6.51761 5.82416 6.87493 5.82373 7.2476V8.6779H10.6767V7.2476C10.6765 7.1062 10.6561 6.96699 10.6172 6.83426H10.1375ZM9.1938 7.1179H9.4634V6.83426H9.1938V6.55065H8.9242V6.83426H8.6546V7.1179H8.9242V7.4015H9.1938V7.1179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41794 5.59881C9.31134 5.59881 10.0355 4.83743 10.0355 3.89823C10.0355 2.95901 9.31134 2.19763 8.41794 2.19763C7.52454 2.19763 6.80029 2.95901 6.80029 3.89823C6.80029 4.83743 7.52454 5.59881 8.41794 5.59881Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8017_7420",
    x: 0.809082,
    y: 0,
    width: 4.85303,
    height: 10.8023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8017_7420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8017_7420",
    x: 5.82373,
    y: 2.19763,
    width: 4.85303,
    height: 10.4803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8017_7420"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUsersAndRolesHover);
export default __webpack_public_path__ + "static/media/Menu-Users-and-roles-hover.47de3058c5a08d370ed5c5b29e0337bb.svg";
export { ForwardRef as ReactComponent };